// @import dependencies
import React, {Component, ReactChild} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {IconsCommonLayout} from 'app_components/commons/icons'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import {IFontawesomeIcon} from 'app_types/components/icon/fontawesomeTypes'
// @end

// @ADD Component types
interface IIconsCommonProps {
  svg?: string
  fontawesome?: IFontawesomeIcon
  component?: ReactChild
  class_name?: string
  color?: any
  height?: any
  width?: any
  data_tip?:any
  onClick?: () => any
}
interface IIconsCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class IconsCommon extends Component<IIconsCommonProps, IIconsCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IIconsCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <IconsCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(IconsCommon)
